<button
  #button
  [coreUiMousePosition]="hasMouseAnimation"
  [attr.type]="loading ? 'button' : type"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel || null"
  [attr.aria-haspopup]="ariaHasPopup || null"
  [attr.aria-expanded]="ariaExpanded ?? null"
  [attr.aria-controls]="ariaControls || null"
  [attr.aria-current]="ariaCurrent || null"
  [attr.aria-busy]="loading"
  [attr.aria-disabled]="disabled || loading"
  [ngClass]="[
    'klab-btn',
    variantClass,
    colorClass,
    appearanceClass,
    size ? 'klab-btn--' + size : '',
    block ? 'klab-btn--block' : '',
    stretch ? 'klab-btn--stretch' : '',
    iconOnly ? 'klab-btn--icon-only' : '',
    active ? 'klab-btn--active' : '',
    disabled ? 'klab-btn--disabled' : '',
    loading ? 'klab-btn--loading' : '',
    loading ? 'loading' : '',
    hasMouseAnimation ? 'klab-btn--mouse-animation' : '',
    btnClass
  ]"
  [style.height]="height || null"
  (click)="onClick($event)"
>
  <span class="klab-btn__content">
    <core-ui-inline-loading
      *ngIf="loading; else buttonContent"
      [sizePx]="22"
      [variant]="loadingVariant"
      color="currentColor"
    ></core-ui-inline-loading>

    <ng-template #buttonContent>
      <ng-container *ngIf="icon || label; else projectedContent">
        <core-ui-icon
          *ngIf="icon"
          [name]="icon"
          [size]="iconPresetSize"
          [style.width.px]="customIconSizePx"
          [style.height.px]="customIconSizePx"
          [direction]="iconDirection"
          [color]="iconColor"
          [extraClass]="iconClass"
        ></core-ui-icon>

        <span *ngIf="label" class="klab-btn__label">{{ label }}</span>
      </ng-container>
    </ng-template>

    <ng-template #projectedContent>
      <ng-content></ng-content>
    </ng-template>
  </span>
</button>
